export type ComputeAiPipelineProgressParams = {
  stepCount: number;
  activeStepIndex: number;
  elapsedMs: number;
  stepIntervalMs: number;
};

export type AiPipelineProgressSnapshot = {
  stepNumber: number;
  stepCount: number;
  estimatedProgressPercent: number;
};

export function computeAiPipelineProgress({
  stepCount,
  activeStepIndex,
  elapsedMs,
  stepIntervalMs,
}: ComputeAiPipelineProgressParams): AiPipelineProgressSnapshot {
  const safeStepCount = Math.max(stepCount, 1);
  const clampedIndex = Math.min(Math.max(activeStepIndex, 0), safeStepCount - 1);
  const estimatedTotalMs = Math.max(stepIntervalMs * safeStepCount, 1);
  const estimatedProgressPercent = Math.min(
    98,
    Math.round((Math.max(elapsedMs, 0) / estimatedTotalMs) * 100)
  );

  return {
    stepNumber: clampedIndex + 1,
    stepCount: safeStepCount,
    estimatedProgressPercent,
  };
}
